/** Topic for widget → agent presence signals (composer state, etc.). Must match agent.py. */
export const USER_ACTIVITY_TOPIC = "lk.user_activity";
